import React, { Component } from 'react';
import { Grid, Dropdown, Form, Segment, Header } from 'semantic-ui-react';
import MessageBox from '../../ui/MessageBox';
import validation from '../../components/SimpleReactValidation';
import Loading from '../Loading';
class SearchFilter extends Component {
    constructor(props) {
        super(props);
        this.validator = validation();
        this.state = {
            errorMessage: [],
            open: false
        }
    }

    handleSubmit = (e, pdf) => {
        e.preventDefault();
        if (this.validator.allValid()) {
            this.props.handleSubmit(pdf);
        } else {
            this.setState({
                errorMessage: this.props._errorItems(this.validator.fields),
                open: true
            });
            this.forceUpdate();
        }
    }

    close = () => {
        this.setState({
            open: false
        });
    }

    render() {
        return (
            <Grid className="g-bkgd">
                {this.props.loading ? <Loading /> : ""}
                <Grid.Row>
                    <Grid.Column>
                        <Segment.Group raised>
                            <Segment inverted className="grey">
                                <Header as="h4">{this.props.reportTitle}</Header>
                            </Segment>
                            <Segment>
                                <Form className="small">
                                    <Form.Group>
                                        <Form.Field width={6} className="required">
                                            <label>Select Client ID:</label>
                                            <Dropdown placeholder='Select Client ID' className="fluid" /*multiple*/ search selection options={this.props.items.clients.map((client) => { client.disabled = !client.allowedtoviewreport; return client; })} value={this.props.cltClientId} name="cltClientId" onChange={this.props.handleChange}></Dropdown>
                                            {this.validator.message('Client ID', this.props.cltClientId, 'required')}
                                        </Form.Field>
                                        <Form.Field width={5} className="required" disabled={this.props.disabled}>
                                            <label className="required" >Report Date:</label>
                                            <Form.Select placeholder="Select" options={this.props.reportDates} value={this.props.date} name="date" onChange={this.props.handleChange} />
                                            {this.validator.message('Report Date', this.props.date, 'required')}
                                        </Form.Field>
                                        <Form.Field width={5}>
                                            <Dropdown text='Export Table Data' icon='external alternate' labeled className='icon button small floated push-down'>
                                                <Dropdown.Menu>
                                                    <Dropdown.Item onClick={(e) => { this.handleSubmit(e, true) }} > Export as pdf</Dropdown.Item>
                                                    <Dropdown.Item onClick={(e) => { this.handleSubmit(e, false) }}> Export as excel</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </Form.Field>
                                    </Form.Group>
                                </Form>
                            </Segment>
                        </Segment.Group>
                    </Grid.Column>
                </Grid.Row>
                <MessageBox {...this.props} size="mini" box={11} open={this.state.open} close={this.close} required={this.state.errorMessage} />
            </Grid>
        )
    }
}

export default SearchFilter;


// WEBPACK FOOTER //
// ./src/app/ui/reports/SearchFilter.js